import React from "react";

const Stepper = ({ currentStep }) => {
  const steps = [
    { id: 1, title: "Contact Information", subtitle: "01" },
    { id: 2, title: "Specimen Specifications", subtitle: "02" },
    { id: 3, title: "Logistics& Timeline", subtitle: "03" },
    { id: 4, title: "Additional Comments", subtitle: "04" },
  ];

  // Total steps = 4. Distance between centers is 25%.
  // First center is at 12.5%.
  // Progress bar width = (currentStep - 1) * 25%
  const progressWidth = (currentStep - 1) * 25;

  return (
    <div className="w-full max-w-[1800px] mx-auto mb-20 px-4 md:px-12 2xl:px-24">
      <div className="flex items-center justify-between relative">
        {/* Gray Background Line (Total path) */}
        <div
          className="absolute h-[2px] bg-slate-200  top-[25%]"
          style={{
            left: "12.5%",
            right: "12.5%",
          }}
        ></div>

        {/* Active Progress Line */}
        <div
          className="absolute h-[2px] bg-[#183076] transition-all duration-500 ease-in-out top-[25%]"
          style={{
            left: "12.5%",
            width: `${progressWidth}%`,
          }}
        ></div>

        {steps.map((step) => (
          <div
            key={step.id}
            className="flex flex-col items-center flex-1 relative"
          >
            {/* Circle */}
            <div
              className={`w-[40px] md:w-[50px] 2xl:w-[80px] h-[40px] md:h-[50px] 2xl:h-[80px] rounded-full flex items-center justify-center font-bold transition-all duration-300 border-2 relative z-10
              ${
                currentStep >= step.id
                  ? "bg-[#183076] border-[#183076] text-white shadow-lg"
                  : "bg-white border-slate-300 text-slate-400"
              }`}
            >
              <span className="text-[14px] md:text-[18px] 2xl:text-[24px]">
                {step.subtitle}
              </span>
            </div>

            {/* Label */}
            <div className="mt-4 xl:mt-6 text-center">
              <p
                className={`text-[12px] md:text-[18px] 2xl:text-[24px] transition-colors leading-tight
                ${currentStep >= step.id ? "text-[#183076] font-extrabold" : "text-[#183076] font-medium opacity-60"}`}
              >
                {step.title.split(" ").map((word, i) => (
                  <span key={i} className="block">
                    {word}
                  </span>
                ))}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
